import * as e from "react";
import m from "../lib/IconBase.es.js";
import c from "../defs/PersonSimpleCircle.es.js";
const o = e.forwardRef((r, i) => /* @__PURE__ */ e.createElement(m, { ref: i, ...r, weights: c }));
o.displayName = "PersonSimpleCircleIcon";
const n = o;
export {
  n as PersonSimpleCircle,
  o as PersonSimpleCircleIcon
};
